module.exports = __webpack_public_path__ + "media/dorobek/assets/images/logo-science2-dbbebfae2a76ff1b74aafeb201b59488.svg";